import { getCurrencyFlag } from "../../utils/money";

// Maps a currency code to the ISO country code of its circular flag asset in
// public/images/flags. Currencies without an asset fall back to an emoji.
const CURRENCY_TO_COUNTRY: Record<string, string> = {
  NGN: "NG",
  USD: "US",
  KES: "KE",
  GHS: "GH",
  UGX: "UG",
  GBP: "GB",
};

interface FlagProps {
  currency: string;
  /** Tailwind size classes, e.g. "h-6 w-6". */
  className?: string;
}

export default function Flag({ currency, className = "h-6 w-6" }: FlagProps) {
  const country = CURRENCY_TO_COUNTRY[currency];

  if (country) {
    return (
      <img
        src={`/images/flags/${country}.svg`}
        alt={`${currency} flag`}
        className={`${className} shrink-0 rounded-full`}
      />
    );
  }

  // Fallback for currencies without an SVG asset yet.
  const emoji = getCurrencyFlag(currency);
  if (!emoji) return null;

  return (
    <span
      className={`${className} inline-flex items-center justify-center`}
      aria-hidden="true"
    >
      {emoji}
    </span>
  );
}
